/**
 * Compatibility layer for `history` when consumed from ESM bundles.
 *
 * Some older `react-router` builds import named exports (createLocation, createPath, etc).
 * Rspack may treat the underlying CJS `history` package as default-only, emitting warnings.
 */
const history = require('history')

module.exports = history

